import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Maybe } from "@ispb/react-hooks";
import { useEffect } from "react";
import { errorToString, throwError } from "shared/misc";
import { ERROR_ICON, RETRY_ICON } from "../icons.js";
import ErrorPage from "./ErrorPage.js";
import IconButton from "./IconButton.js";
import ResponsiveStack from "./ResponsiveStack.js";
import Spacer from "./Spacer.js";
export default function ButtonsErrorPage(props) {
    useEffect(() => {
        console.error(props.error);
    }, [
        props.error
    ]);
    return (_jsx(ErrorPage, { title: errorToString(props.error), children: _jsxs("div", { className: "text-center", children: [(() => {
                    if (props.error instanceof Error) {
                        return _jsx("code", { children: props.error.stack });
                    }
                })(), _jsx(Spacer, {}), _jsxs(ResponsiveStack, { children: [_jsx(IconButton, { onClick: throwError(props.error), variant: "warning", icon: ERROR_ICON, children: "Throw" }), _jsx(Maybe, { value: props.resetErrorBoundary, children: retry => {
                                return _jsx(IconButton, { variant: "success", onClick: retry, icon: RETRY_ICON, children: "Retry" });
                            } }), props.children] })] }) }));
}
